<template>
  <footer>
    <div class="footer_info">
      <div class="item">
        <div>
          <img src="../assets/icon/logo.png" alt="logo">
        </div>

        <div class="item_box">
          <div class="title">DIKE INTERNATIONAL CO., LIMITED</div>
          <div class="des"><span class="name">Working hours: </span>9AM-6PM (Mon–Sat)</div>
          <div class="des"><span class="name">Address: </span>10/F Easey Commercial Bldg, 253-261</div>
          <div class="des" style="margin-top: -10px">Hennessy Rd, Wanchai, HK</div>
          <div class="des"><span class="name">USA Fulfillment Addr: </span>46595 Landing Parkway Fremont, CA</div>
          <div class="des"><span class="name">CN Fulfillment Addr: </span>Printing Industry Park, Fujian, China</div>
          <div class="des"><span class="name">Email: </span>support@printbelle.com</div>
          <div class="des">
            <span class="name">Social network: </span>
            <a href="https://www.facebook.com/share/hEbhkZ3uadDQqFGg/" target="_blank">
              <img src="../assets/icon/facebook.svg" alt="logo" style="margin-left: 10px;max-width: 24px;max-height: 24px;">
            </a>
            <a href="https://youtube.com/@printbelle?si=PDL-sO2SGepX2CNa" target="_blank">
              <img src="../assets/icon/youtube.svg" alt="logo" style="margin-left: 10px;max-width: 24px;max-height: 24px;">
            </a>
            <a href="https://www.linkedin.com/company/printbelle" target="_blank">
              <img src="../assets/icon/linkin.svg" alt="logo" style="margin-left: 10px;max-width: 24px;max-height: 24px;">
            </a>
            <a v-if="false">
              <img src="../assets/tiktok.png" alt="logo" style="margin-left: 10px">
            </a>
          </div>
        </div>
      </div>
      <div class="item_1" style="margin-left: 240px">
        <div class="title">About Printbelle</div>
        <a @click="goto('About Us')">About Us</a>
        <a @click="gotoThisUrl('/careers')">Careers</a>
        <a :href="skypeConfig">Contact Us</a>
        <a
          @click="gotoUrl('/help/details/membership-introduction')">Membership Introduction</a>
        <a @click="gotoThisUrl('/blog/us')">Blog</a>
        <a
          @click="gotoThisUrl('/legal/terms')">Terms & Conditions</a>
      </div>
      <div class="item_1" style="margin-left: 300px">
        <div class="title">Resources</div>
        <a
          @click="goto('Help Center')">Help Center</a>
        <a
          @click="goto('Faqs')">FAQ</a>
        <a
          @click="gotoUrl('/help/details/how-to-creating-products-in-the-designer')">Mockup tutorial</a>
        <a
          @click="gotoUrl('/help/details/how-can-i-fulfill-orders-with-printbelle')">Create Orders</a>

        <a href="https://documenter.getpostman.com/view/25923095/2s93RL1vvB" target="_blank">API Docs</a>
        <a @click="gotoThisUrl('/integrations')">Integrations</a>
      </div>
    </div>
    <div class="cooperation_box">
      <div class="payment_view">
        <span class="title">Payment methods we accept:</span>
        <img src="../assets/icon/cooperative.png" alt="" style="width: 434px;height: 23px">
      </div>
      <div class="payment_view">
        <span class="title">We deliver with:</span>
        <img src="../assets/icon/logistics2.png" alt="" style="width: 427px;height: 23px">
      </div>
    </div>
    <div class="divide"></div>
    <div class="printbelle">© 2026 Printbelle. All rights reserved</div>
  </footer>
</template>
<script>

import {get} from '@/api'

export default {
  components: {},
  data () {
    return {
      showModal: false,
      skypeConfig: ''
    }
  },
  created () {
    this.getSkypeConfig()
  },
  methods: {
    hideModal () {
      this.showModal = false
    },
    getSkypeConfig () {
      this.skypeConfig = 'msteams://teams.microsoft.com/l/chat/0/0?users=luojiao@printbelle.com'
    },
    goto (name) {
      this.$router.push({name: name})
    },
    gotoUrl (url) {
      window.location.href = url
    },
    gotoThisUrl(url) {
      this.$router.push({ path: url }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      })
    }
  }
}
</script>
<style scoped lang="less">

footer {
  display: flex;
  flex-direction: column;
  height: 546px;
  background: #F2F2F2;
  position: relative;

  .footer_info {
    font-family: HarmonyOS Sans SC;
    display: flex;
    background-image: url(../assets/icon/footer_bg.jpg);
    background-repeat: no-repeat;
    padding-top: 33px;
    padding-left: 320px;


    .item {
      display: flex;
      flex-direction: column;

      .item_box {
        margin-top: 30px;
        margin-bottom: 20px;

        .title {
          font-weight: bold;
          font-size: 20px;
          margin-bottom: 12px;
          color: #111111;
        }

        .des {
          font-weight: 400;
          margin-bottom: 16px;
          font-size: 16px;
          color: #111111;

          .name {
            font-weight: bold;
          }

          a:hover path {
            fill: red;
          }
        }

      }
    }

    .item_1 {
      display: flex;
      flex-direction: column;
      margin-top: 10px;

      .title {
        font-weight: bold;
        font-size: 20px;
        color: #111111;
        margin-bottom: 15px;
      }

      a {
        font-weight: 400;
        font-size: 16px;
        color: #111111;
        line-height: 40px;
        transition: color 0.3s ease;
      }

      a:hover {
        color: #162567;
      }
    }
  }

  .divide {
    width: 1281px;
    height: 1px;
    background: #D2D2D2;
    margin-left: 320px;
    margin-top: 9px;
    margin-bottom: 6px;
  }

  .cooperation_box {
    width: 1281px;
    display: flex;
    justify-content: space-between;
    margin-left: 320px;
    font-weight: 300;
    font-size: 12px;
    color: #111111;

    .payment_view {
      display: flex;
      flex-direction: column;

      .title {
        margin-bottom: 8px;
      }
    }
  }

  .printbelle {
    font-weight: 300;
    font-size: 14px;
    color: #111111;
    display: flex;
    margin-left: 320px;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue